import type { GatsbyBrowser } from "gatsby";
import React from "react";
import "./src/styles/global.css";

export const wrapRootElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return <>{element}</>;
};
